import produce from 'immer';
import { Map as ImmutableMap } from 'immutable';
import Raven from 'raven-js';
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import { PRODUCT_BUILDER_GATE } from 'products-ui-components/constants/permissions';
import { useUpdateProduct } from 'products-ui-components/hooks/useUpdateProduct';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { useProductData } from '../../contexts/ProductDataContext';
import { useUpdateProductAction } from '../../contexts/UpdateProductActionContext';
import { jsx as _jsx } from "react/jsx-runtime";
const onError = err => {
  Raven.captureException(err);
};
export const ProductHighlightStatusToggleButton = () => {
  const product = useProductData();
  const updateProduct = useUpdateProductAction();
  const {
    hasGate,
    hasScope
  } = usePermissionsContext();
  const onUpdateProduct = useCallback(({
    subject,
    modifiedProperties
  }) => updateProduct(ImmutableMap(Array.from(modifiedProperties).map(propertyName => [propertyName, getProperty(subject, propertyName)]))), [updateProduct]);
  const handleUpdateStatus = useUpdateProduct({
    onUpdate: onUpdateProduct,
    onError
  });
  const handleToggleStatus = useCallback(() => {
    if (!product) return;
    const currentStatus = getProperty(product, 'hs_status');
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    handleUpdateStatus({
      subject: produce(product, draft => {
        draft.properties.hs_status = {
          name: 'hs_status',
          value: newStatus
        };
      }),
      modifiedProperties: new Set(['hs_status']),
      addAnother: false
    });
  }, [product, handleUpdateStatus]);
  const isUserUngatedForProductEditor = hasGate(PRODUCT_BUILDER_GATE);
  const hasProductEditScope = hasScope('inbounddb-product-library-write');
  if (!product || !isUserUngatedForProductEditor || !hasProductEditScope) {
    return null;
  }
  const isProductActive = getProperty(product, 'hs_status') === 'active';
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    onClick: handleToggleStatus,
    "data-test-id": "product-status-toggle-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: isProductActive ? 'actions.deactivate' : 'actions.activate'
    })
  });
};